import { Component, Vue, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import KnowledgePanel from '../knowledge-panel/knowledge-panel';
import CommunityPanel from '../community-panel/community-panel';
import { SubjectModel } from '@/models/taxonomy/subject';
import { ClassificationModel } from '@/models/taxonomy/classification';
import { DomainModel } from '@/models/proficiency/domain';
import moment from 'moment';
import MindsetsPanel from '../mindsets-panel/mindsets-panel';

import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';
import DomainJourneyPanelComponent from '../domain-journey-panel/domain-journey-panel';
import { UserClassModel } from '@/models/class/class';

@Component({
  name: 'domain-info-panel',
  components: {
    'google-material-icon': GoogleMaterialIcon,
    MindsetsPanel,
    KnowledgePanel,
    CommunityPanel,
    'domain-journey-panel': DomainJourneyPanelComponent,
  },
})
export default class DomainInfoPanel extends Vue {

  @Prop()
  public domain!: Domain;

  @Prop()
  public subject!: SubjectModel;

  @Prop()
  public topic!: Topic;

  @Prop()
  public classification!: ClassificationModel;

  @Prop()
  public activeToggleList?: string;

  @Prop()
  public portfolioDomain: any;

  @Prop()
  public activeClasses!: UserClassModel[];

  @Prop()
  public isShowcasePage!: boolean;

  public activeTab: object = {
    title: 'Knowledge',
    component: KnowledgePanel,
  };

  public tabItems = [
    {
      title: 'Knowledge',
      component: KnowledgePanel,
    },
    {
      title: this.isShowcasePage ? 'Journey' : 'Mindset',
      component: this.isShowcasePage ? 'domain-journey-panel' : MindsetsPanel,
    },
    {
      title: 'Citizenship',
      component: CommunityPanel,
    },
  ];

  private get isSuperUser() {
    return this.$access.hasPermission('all', 'all');
  }

  @Prop()
  private userId!: string;

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  public onSelectCompetency(competency: Competency) {
    this.$emit('onSelectCompetency', competency);
  }

  public onSelectTopic(topic: Topic) {
    this.topic = topic;
    this.$emit('onSelectTopic', topic);
  }

  private onSelectPortfolioStat(portfolio: any) {
    this.$emit('onSelectPortfolioStat', portfolio);
  }
}
